export default __webpack_public_path__ + "static/banner_home_2-775e46a96d30a9a7a859287e832b01ba.jpg";